module.exports = __webpack_public_path__ + "img/tongweb.2bda9a61.svg";